import React, { createContext, useState } from "react";
import { Header } from "../components";

const HeaderContext = createContext();

const HeaderProvider = ({ children, brand }) => {
  const [title, setTitle] = useState("");
  const [headerHeight, setHeaderHeight] = useState(0);

  return (
    <HeaderContext.Provider value={{ setTitle, headerHeight }}>
      <Header title={title} setHeight={setHeaderHeight} brand={brand} />
      <HeaderContext.Consumer>{() => children}</HeaderContext.Consumer>
    </HeaderContext.Provider>
  );
};

const useHeader = () => React.useContext(HeaderContext);

export { HeaderProvider, useHeader };
